import React from 'react';
import SideContainerComponent from '../SideContainer.component';
import { MainContentContainer, MainSection } from '../OtherPages.styles';
import {
  ResourcesContainer,
  SectionContainer,
  GroupHeader,
  ResourcesIntro,
  ResourcesGroup,
  ResourceRow,
} from './ResourcePage.styles';
import Breadcrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import { FaFileAlt, FaExternalLinkAlt, FaShieldAlt } from 'react-icons/fa';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import PageHeader from '../../Components/PageHeader/PageHeader.component';
import { Links, AdditionalLinks } from './Links';

const Resources = () => {
  return (
    <MainContentContainer>
      <HelmetHelper
        title="Health & Safety Resources"
        description="Access helpful workplace health and safety resources, documents, and reference materials for employers and workers across Atlantic Canada."
      />
      <SideContainerComponent />
      <MainSection>
        <Breadcrumbs one="Home" oneLink="/" two="Resources" />
        <PageHeader
          eyebrow="Resources"
          title="Canadian Safety Regulations"
          desc="Workplace regulations for each province"
        />
        <SectionContainer>
          <ResourcesIntro>
            <p>
              Access official workplace safety regulations, occupational health
              & safety standards, and compliance resources for provinces across
              Canada.
            </p>
          </ResourcesIntro>

          <ResourcesGroup>
            <GroupHeader>
              <h3>Provincial Safety Regulations</h3>
              <span>Official provincial resources and workplace standards</span>
            </GroupHeader>

            <ResourcesContainer>
              {Links.map((link) => (
                <ResourceRow
                  key={link.province}
                  href={link.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="left">
                    <FaFileAlt className="resourceIcon" />

                    <span>{link.province}</span>
                  </div>

                  <FaExternalLinkAlt className="arrowIcon" />
                </ResourceRow>
              ))}
            </ResourcesContainer>
          </ResourcesGroup>

          <ResourcesGroup>
            <GroupHeader>
              <h3>Additional Safety Resources</h3>
              <span>Helpful safety and compliance information</span>
            </GroupHeader>

            <ResourcesContainer>
              {AdditionalLinks.map((link) => (
                <ResourceRow
                  key={link.province}
                  href={link.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="left">
                    <FaShieldAlt className="resourceIcon" />

                    <span>{link.province}</span>
                  </div>

                  <FaExternalLinkAlt className="arrowIcon" />
                </ResourceRow>
              ))}
            </ResourcesContainer>
          </ResourcesGroup>
        </SectionContainer>
      </MainSection>
    </MainContentContainer>
  );
};

export default Resources;
